import { Container } from "@components/wrapper"
import { Disclosure, Transition } from "@headlessui/react"
import { FAQ } from "@interfaces/school"
import { createMarkup } from "@lib/functions"
import clsx from "clsx"
import React from "react"
import { AiOutlinePlus } from "react-icons/ai"
import { BootcampHeading } from "../general/ProgramHeading"

export const BootcampFaq = ({ faqs }: { faqs: FAQ[] }) => {
  if (!faqs.length) return <></>

  return (
    <Container className={clsx("sm:py-20 py-10", "sm:flex justify-between grid sm-only:gap-6")}>
      <div className="relative">
        <BootcampHeading id="faqs" title="faq" subTitle="Pertanyaan Seputar Bootcamp" />
      </div>
      <div className="sm:w-3/4 grid sm:gap-6 gap-3">
        {faqs.map((value, index) => (
          <Disclosure key={index}>
            {({ open }) => (
              <div className="border-b border-new-grey">
                <Disclosure.Button
                  className={clsx(
                    "flex justify-between items-center w-full text-primary-black font-medium",
                    "sm:pb-4 sm:text-xl pb-3 text-sm"
                  )}
                >
                  <div className="w-[95%] sm:line-clamp-1 text-left" title={value.faq_question}>
                    {value.faq_question}
                  </div>
                  <AiOutlinePlus />
                </Disclosure.Button>
                <Transition
                  show={open}
                  enter="transition duration-100 ease-out"
                  enterFrom="transform scale-95 opacity-0"
                  enterTo="transform scale-100 opacity-100"
                  leave="transition duration-75 ease-out"
                  leaveFrom="transform scale-100 opacity-100"
                  leaveTo="transform scale-95 opacity-0"
                >
                  <Disclosure.Panel static>
                    <div
                      className="sm:pb-4 pb-3 text-secondary-grey markup-faq"
                      dangerouslySetInnerHTML={createMarkup(value.faq_answer)}
                    />
                  </Disclosure.Panel>
                </Transition>
              </div>
            )}
          </Disclosure>
        ))}
      </div>
    </Container>
  )
}
